/**
 * About the Studio (Home editorial closer; mockup about-page.html Frame 1).
 *
 * about-page-reskin §5.1 (design D9): the WHOLE card is ONE interactive control —
 * a single button whose entire surface opens the About page (the app's `/about` with
 * the recipient token, the website's `/about`: each side passes it), with an accessible
 * name carrying the studio name.
 * The "Read more" line is a styled NON-focusable element inside it — never a nested
 * button (no button-in-button). Always shown (no content-threshold gating in v1).
 * `aboutImageUrl: null` → gradient fallback.
 */
import type { DashboardBusiness } from '@/types/dashboard';
import styles from '../BookingHubPage.module.css';

export interface AboutCardProps {
  business: DashboardBusiness;
  /** Opens the About page (shared-client-screens H10): no shared view navigates by itself. */
  onOpen: () => void;
}

export function AboutCard({ business, onOpen }: AboutCardProps) {
  return (
    <button
      type="button"
      className={styles.aboutCard}
      data-testid="home-about"
      aria-label={`About ${business.name}`}
      onClick={onOpen}
    >
      {/* spans (not divs): a <button> only permits phrasing content — the classes carry display:block */}
      <span
        className={`${styles.aboutPhoto} ${business.aboutImageUrl ? '' : styles.aboutPhotoFallback}`}
        style={business.aboutImageUrl ? { backgroundImage: `url('${business.aboutImageUrl}')` } : undefined}
      />
      <span className={styles.aboutText}>
        <span className={styles.aboutKicker}>About</span>
        <span className={styles.aboutName}>{business.name}</span>
        {business.about.trim() && <span className={styles.aboutBio}>{business.about}</span>}
        <span className={styles.aboutReadmore} aria-hidden="true">
          Read more
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
      </span>
    </button>
  );
}
